define('editor/edit/layers/index',['utils', 'durandal/system', 'durandal/app', 'jquery', 'plugins/http', 'plugins/dialog', 'knockout', 'durandal/app', 'jqueryui'], function (utils, system, app, $, http, dialog, ko) {
    var viewmodel = function () {
        var self = this;

        self.mapId = null;
        self.activeTabContent = ko.observable();
        self.isListView = ko.observable(true);

        self.activate = function (map) {
            self.map = map;
            self.mapId = map.id;
            self.readOnly = map.readOnly;

            self.activateLayersList(true);
        };

        self.noPermission = function(heading) {
            app.showMessage('You do not have permission to edit this map.', heading);
        };

        self.activateModule = function (modulePath) {
            self.activeTabContent({ model: modulePath, activationData: [self.mapId, self.activateLayersList] });
        };

        self.activateLayersList = function (needsActivation) {
            self.isListView(true);
            self.activeTabContent({ model: 'editor/edit/layers/list/index', activationData: [self.map, self.activateEditLayer, self.activateEditLayerGroup], activate: !!needsActivation });
        };

        self.activateEditLayer = function (layer) {
            if (!self.readOnly) {
                var modelPath = 'editor/edit/layers/edit/' + layer.type().toLowerCase();

                self.isListView(false);
                self.activeTabContent({ model: modelPath, activationData: [self.mapId, layer, self.activateLayersList] });
            } else {
                self.noPermission('Cannot Edit Layer');
            }
        };

        self.activateEditLayerGroup = function(group, childLayers) {
            var section = utils.getSectionNameForLayerType(childLayers[0].type()),
                allSameType = ko.utils.arrayGetDistinctValues(ko.utils.arrayMap(childLayers, function (layer) {
                    return layer.type();
                })).length === 1,
                modelPath = 'editor/edit/layers/edit/',
                layersExcludingDirections = ko.utils.arrayFilter(childLayers, function(layer) {
                    return layer.type() !== "Directions";
                }),
                containsDirections = layersExcludingDirections.length !== childLayers.length;

            modelPath += (containsDirections && allSameType) ? 'basicGroup' : section; // directions are special case where marker edit options cannot be applied

            self.isListView(false);
            self.activeTabContent({ model: modelPath, activationData: [self.mapId, group, layersExcludingDirections, self.activateLayersList] });
        };

        self.activateNewLayer = function () {
            if (!self.readOnly) {
                self.activeTabContent({ model: 'editor/edit/layers/add/index', activationData: [self.mapId, self.activateModule, self.activateLayersList] });
            } else {
                self.noPermission('Cannot Add Layer');
            }
        };
        
        self.activateNewLayerGroup = function () {
            if (!self.readOnly) {
                app.trigger('layer:group:create');
            } else {
                self.noPermission('Cannot Add Group');
            }
        };
    };

    return viewmodel;
});

